import { AxiosRequestConfig } from 'axios'

import { CreateTagPayload, GetTotalUsersWithAllTagsPayload, UpdateTagData } from './types'

const getTags = (): AxiosRequestConfig => ({
  url: '/tags',
  method: 'GET',
})

const getActiveTags = (params?: { group?: string; includeIds?: number[] }): AxiosRequestConfig => {
  const searchParams = new URLSearchParams()
  if (params?.group) searchParams.set('group', params.group)
  if (params?.includeIds?.length) searchParams.set('includeIds', params.includeIds.join(','))
  const query = searchParams.toString()

  return {
    url: `/tags/active${query ? `?${query}` : ''}`,
    method: 'GET',
  }
}

const createTag = (tag: CreateTagPayload): AxiosRequestConfig => {
  const payload = new FormData()

  payload.append('title', tag.title)
  payload.append('description', tag.description)
  payload.append('active', tag.active.toString())

  if (tag.group) {
    payload.append('group', tag.group)
  }
  if (tag.subgroup) {
    payload.append('subgroup', tag.subgroup)
  }

  if (tag.icon) {
    // Si es un File lo mandamos directo, si es string (URL), lo mandamos como texto (o lo puedes ignorar si solo aceptas archivos nuevos)
    if (typeof tag.icon === 'string') {
      payload.append('icon', tag.icon)
    } else {
      payload.append('icon', tag.icon) // tipo File
    }
  }

  return {
    url: '/tags',
    method: 'POST',
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
}

const updateTag = (data: UpdateTagData): AxiosRequestConfig => {
  const payload = new FormData()
  const { title, description, active, icon, group, subgroup } = data.payload

  if (title) payload.append('title', title)
  if (description) payload.append('description', description)
  if (group) payload.append('group', group)
  if (subgroup) payload.append('subgroup', subgroup)

  // Siempre enviar activo como string
  payload.append('active', String(active)) // 'true' o 'false'

  if (icon && typeof icon !== 'string') {
    payload.append('icon', icon)
  } else if (icon === '') {
    payload.append('icon', '') // Borrar icono si fue eliminado
  }

  return {
    url: `/tags/${data.id}`,
    method: 'PUT',
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
}

const deleteTag = (id: number): AxiosRequestConfig => ({
  url: `/tags/${id}`,
  method: 'DELETE',
})

const getTotalUsersWithAllTags = (data: GetTotalUsersWithAllTagsPayload): AxiosRequestConfig => {
  return {
    url: `/tags/total-users`,
    method: 'POST',
    data: { tags: data.tagIds.toString() },
  }
}

export { getTags, createTag, updateTag, deleteTag, getActiveTags, getTotalUsersWithAllTags }
